import { apiClient } from './apiClient.js';
import type {
  ApiResponse,
  PaginatedResponse,
  OpenRoleDetail,
  OpenRole,
  CreateOpenRoleRequest,
  UpdateOpenRoleRequest,
} from '@onboarding-dashboard/shared';

export const rolesService = {
  async list(params?: {
    page?: number;
    pageSize?: number;
    status?: string;
    department?: string;
  }): Promise<ApiResponse<PaginatedResponse<OpenRoleDetail>>> {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.pageSize) query.set('pageSize', String(params.pageSize));
    if (params?.status) query.set('status', params.status);
    if (params?.department) query.set('department', params.department);
    const qs = query.toString();
    return apiClient.get<PaginatedResponse<OpenRoleDetail>>(`/roles${qs ? `?${qs}` : ''}`);
  },

  async getById(id: string): Promise<ApiResponse<OpenRoleDetail>> {
    return apiClient.get<OpenRoleDetail>(`/roles/${id}`);
  },

  async create(data: CreateOpenRoleRequest): Promise<ApiResponse<OpenRoleDetail>> {
    return apiClient.post<OpenRoleDetail>('/roles', data);
  },

  async update(id: string, data: UpdateOpenRoleRequest): Promise<ApiResponse<OpenRoleDetail>> {
    return apiClient.patch<OpenRoleDetail>(`/roles/${id}`, data);
  },

  async close(id: string): Promise<ApiResponse<OpenRole>> {
    return apiClient.delete<OpenRole>(`/roles/${id}`);
  },
};
